<template>
  <v-dialog v-model="showContratsTab">
    <v-card>
      <v-col align="center" class="pb-1 mt-2" style="font-size: 22px; font-weight: bold">
        Client en attente d'intervention
      </v-col>

      <v-col>
        <v-divider class="mb-5"></v-divider>
        <Vue3EasyDataTable
          empty-message="Aucun contrat trouvé"
          rows-per-page-message="Client par page"
          :headers="clientKeyToShow"
          :items="getClientsPosition"
          :table-height="windowHeight * 0.7"
          @click-row="showClientData"
        >
          <template #item-dataSortie="item">
            <div
              style="background-color: #a5d6a7; font-weight: bold"
              align="center"
              class="pa-2"
            >
              <div v-if="item.dataSortie && item.dataSortie.length">
                {{ item.dataSortie.length }}
              </div>
              <div v-else>0</div>
            </div>
          </template>
          <template #item-dataStock="item">
            <div
              style="background-color: #9fa8da; font-weight: bold"
              align="center"
              class="pa-2"
            >
              <div v-if="item.dataStock && item.dataStock.length">
                {{ item.dataStock.length }}
              </div>
              <div v-else>0</div>
            </div>
          </template>
        </Vue3EasyDataTable>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="markerDataToShow.show" width="90%" max-width="1700px">
    <v-card>
      <v-col align="center" style="font-weight: bold; font-size: 25px">
        {{ markerDataToShow.data.client }}
      </v-col>
      <v-divider></v-divider>
      <v-col>
        <v-row>
          <v-col cols="6" style="background-color: #a5d6a7">
            <v-col align="center">
              <v-chip style="background-color: white; color: black; font-weight: bold">
                À récupérer
              </v-chip>
            </v-col>
            <Vue3EasyDataTable
              empty-message="Aucun contrat trouvé"
              rows-per-page-message="Contrat par page"
              :headers="contratKeyToShow"
              :items="markerDataToShow.data.dataSortie"
              :table-height="windowHeight * 0.65"
            >
              <template #item-CLD_DATE_LIVRAISON_DEPART="item">
                {{ formatDate(item["CLD_DATE_LIVRAISON_DEPART"]) }}
              </template>
              <template #item-CLD_DATE_LIVRAISON_RETOUR="item">
                {{ formatDate(item["CLD_DATE_LIVRAISON_RETOUR"]) }}
              </template>
            </Vue3EasyDataTable>
          </v-col>
          <v-col cols="6" style="background-color: #9fa8da">
            <v-col align="center">
              <v-chip style="background-color: white; color: black; font-weight: bold">
                À livrer
              </v-chip>
            </v-col>
            <Vue3EasyDataTable
              empty-message="Aucun contrat trouvé"
              rows-per-page-message="Contrat par page"
              :headers="contratKeyToShow"
              :items="markerDataToShow.data.dataStock"
              :table-height="windowHeight * 0.65"
            >
              <template #item-CLD_DATE_LIVRAISON_DEPART="item">
                {{ formatDate(item["CLD_DATE_LIVRAISON_DEPART"]) }}
              </template>
              <template #item-CLD_DATE_LIVRAISON_RETOUR="item">
                {{ formatDate(item["CLD_DATE_LIVRAISON_RETOUR"]) }}
              </template>
            </Vue3EasyDataTable>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="validationModal" persistent>
    <v-btn
      icon="mdi-close"
      style="
        background-color: red;
        color: white;
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 5;
      "
      @click="validationModal = false"
      density="compact"
    >
    </v-btn>
    <!-- :cmpHeight="windowHeight * 0.7 - 78 + 'px'" -->
    <itineraire-edition
      :mainItineraireValidTab="itineraireValidTab"
      :clearItineraireValidTab="clearItineraireValidTab"
      :addEvent="addEvent"
      :editEvent="editEvent"
      :deleteEvent="deleteEvent"
      :showValidatedItineraire="showValidatedItineraire"
      :driversListe="driversListe"
      :typeListe="typeListe"
      :dateChange="dateChange"
      :showTimePanel="showTimePanel"
      :getMaxPoid="getMaxPoid"
      :reloadIteneraire="reloadIteneraire"
      :itineraireDataSaved="itineraireDataSaved"
      :toggleTimePanel="toggleTimePanel"
      :itineraireOrderLastVue="getItineraireOrderLastVue"
      :itineraireOrderInitialValue="itineraireOrderInitialValue"
    ></itineraire-edition>
  </v-dialog>
  <div>
    <v-card>
      <v-col cols="12" class="gestionLivraison">
        <v-row>
          <v-col cols="12" md="6" class="pa-0" style="position: relative">
            <v-card
              v-if="!showCalendarEdition"
              class="pa-2"
              style="border-radius: 0px; position: relative"
              variant="flat"
            >
              <withdrawal-list
                :isPathLoaded="isPathLoaded"
                :getAgencyFiltered="getAgencyFiltered"
                :cmpHeight="windowHeight - 257 + 'px'"
                :position="getClientsPosition"
                :itineraireOrder="getItineraireOrder"
                :setItineraireOrder="setItineraireOrder"
                :validItineraire="validItineraire"
                :showFullPath="showFullPath"
                :agencyFilter="agencyFilter"
                @updateFilter="updateFilter($event)"
                :gpsPositionByClient="gpsPositionByClient"
                :lastItineraireOrder="itineraireOrder"
              ></withdrawal-list>
            </v-card>
            <itineraire-calendar
              v-else
              :calendarOptions="calendarOptions"
            ></itineraire-calendar>
          </v-col>
          <v-col cols="12" md="6" class="pa-0" style="position: relative">
            <div
              id="mapContainer"
              :style="{ height: windowHeight - 60 + 'px' }"
            ></div>
            <v-card
              variant="flat"
              color="transparent"
              style="
                position: absolute;
                left: 55px;
                top: 12px;
                font-size: 15px;
                width: 300px;
                border: solid 1px grey;
              "
            >
              <!-- <v-col> -->
              <!-- <v-row> -->
              <!-- periodListe -->
              <!-- <v-col cols="auto"> Contrats à afficher </v-col> -->
              <v-select
                variant="solo"
                bg-color="rgb(255,255,255,0.8)"
                hide-details
                :items="periodListe"
                return-object
                label="En attente d'intervention"
                v-model="contratPeriode"
              ></v-select>
              <!-- <v-col class="pa-1">
                <v-btn @click="setNewNrbDayToShow(1)">J+0</v-btn>
              </v-col>
              <v-col class="pa-1">
                <v-btn @click="setNewNrbDayToShow(7)">J+7</v-btn>
              </v-col>
              <v-col class="pa-1">
                <v-btn @click="setNewNrbDayToShow(30)">J+30</v-btn>
              </v-col> -->
              <!-- </v-row> -->
              <!-- </v-col> -->
            </v-card>
            <v-btn
              style="
                position: absolute;
                left: 10px;
                top: 85px;
                font-size: 15px;
                border: solid 1px grey;
                background-color: #5c6bc0;
                color: white;
              "
              size="38"
              icon="mdi-table"
              @click="showContratsTab = true"
            >
            </v-btn>
            <v-btn
              @click="showCalendarEdition = !showCalendarEdition"
              style="
                left: 10px;
                top: 130px;
                position: absolute;
                background-color: green;
                color: white;
                font-size: 15px;
                border: solid 1px grey;
              "
              size="38"
              :icon="!showCalendarEdition ? 'mdi-calendar' : 'mdi-plus'"
            >
            </v-btn>

            <map-gps
              v-if="itineraireOrder.data && itineraireOrder.data.length > 0"
              style="position: absolute; top: 8px; bottom: 0px; right: 0px"
              :mapIsLoading="mapIsLoading"
              :getItineraireTotalSummary="getItineraireTotalSummary"
              :cmpHeight="windowHeight - 180 + 'px'"
              :itineraireOrder="itineraireOrder"
              :setItineraireOrderUp="setItineraireOrderUp"
              :validItineraire="validItineraire"
              :setItineraireOrderDown="setItineraireOrderDown"
              :deleteFromItineraire="deleteFromItineraire"
              :getMaxPoid="getMaxPoid"
              :itineraireDataSaved="itineraireDataSaved"
              :gpsPositionByClient="gpsPositionByClient"
            >
            </map-gps>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import "@fullcalendar/vue3";
import "@fullcalendar/core/vdom"; // solves problem with Vite

import mapsSettings from "../hooks/maps";
import calendarData from "../hooks/calendar";
import "vuetify/styles"; // Global CSS has to be imported

import moment from "moment";
import { uuid } from "vue-uuid";
import { ref } from "@vue/reactivity";
import { onMounted, onUnmounted, watch } from "vue";

import mapGps from "./map-gps.vue";
import itineraireCalendar from "./itineraire-calendar.vue";
import itineraireEdition from "./itineraire-edition.vue";
import withdrawalList from "./withdrawal-list.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";

import engine from "../core/DataApi";
import _ from "lodash";
import { computed } from "@vue/runtime-core";

export default {
  setup() {
    const mapIsLoading = ref(false);
    const showCalendarEdition = ref(true);
    const validationModal = ref(false);
    const itineraireOrderInitialValue = ref({});

    const showValidator = function () {
      validationModal.value = true;
      console.log("showValidator");
    };

    const periodListe = ref([
      { value: [0, 1], title: "Aujourdh'hui" },
      { value: [0, 3], title: "Sur 3 jours (à venir)" },
      { value: [0, 7], title: "Sur 7 jours (à venir)" },
      { value: [3, 3], title: "Sur ± 3 jours (passé et à venir)" },
      { value: [7, 7], title: "Sur ± 7 jours (passé et à venir)" },
      { value: [30, 30], title: "Sur ± 30 jours (passé et à venir)" },
    ]);

    const contratPeriode = ref(periodListe.value[2]);

    watch(contratPeriode, () => {
      setNewNrbDayToShow(contratPeriode.value);
    });

    const {
      map,
      position,
      itineraireDataSaved,
      itineraireOrder,
      agencyFilter,
      getItineraireTotalSummary,
      itineraireValidTab,
      driversListe,
      typeListe,
      showFullPath,
      clearMap,
      validItineraire,
      showValidatedItineraire,
      eventsColor,
      getUnknowAd,
      getClientsPosition,
      getClientsAllPath,
      verifItineraire,
      gpsPositionByClient,
      itineraireOrderLastVue,
      reloadIteneraire,
      markerDataToShow,
      setNewNrbDayToShow,
      getContratByClient,
      getContrat,
    } = mapsSettings(showValidator);

    const windowHeight = ref(window.innerHeight);

    function updateHeight() {
      windowHeight.value = window.innerHeight;
    }

    onMounted(() => {
      setNewNrbDayToShow(contratPeriode.value);
      window.addEventListener("resize", updateHeight);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateHeight);
    });

    const getItineraireOrder = computed(function () {
      return _.cloneDeep(itineraireOrder.value);
    });

    const getItineraireOrderLastVue = computed(function () {
      return _.cloneDeep(itineraireOrderLastVue.value);
    });

    const formatToShow = function (data) {
      let newData = [];

      for (let i = 0; i < data.length; i++) {
        let tmpData = {
          title: data[i].CLD_NUM_CONTRAT + " - " + data[i].CLD_MATRICULE,
          CLD_ID_CONTRAT_LOC_DATA: data[i].CLD_ID_CONTRAT_LOC_DATA,
          CLD_DESCRIPTION: data[i].CLD_DESCRIPTION,
          CLD_MATRICULE: data[i].CLD_MATRICULE,
          CLD_NUM_CONTRAT: data[i].CLD_NUM_CONTRAT,
          CLD_SOUS_FAMILLE: data[i].CLD_SOUS_FAMILLE,
          CLD_DATE_RETOUR: data[i].CLD_DATE_RETOUR,
          CLD_DATE_DEPART: data[i].CLD_DATE_DEPART,
          CLD_POIDS: data[i].CLD_POIDS,
          CLD_NOM_CLIENT: data[i].CLD_NOM_CLIENT,
        };

        newData.push(tmpData);
      }

      return newData;
    };

    const eventClicked = async function (eventData) {
      let filteredEvent = {};
      filteredEvent.name = eventData.event._def.extendedProps.name;
      filteredEvent.start = moment(eventData.event.start).format("YYYY-MM-DD HH:mm");
      filteredEvent = {
        ...filteredEvent,
        ...JSON.parse(JSON.stringify(eventData.event._def.extendedProps)),
      };

      filteredEvent.id = eventData.event._def.publicId;
      itineraireOrderLastVue.value = filteredEvent.itineraire;
      delete filteredEvent.itineraire;

      clearMap();
      itineraireOrder.value.data = [];
      mapIsLoading.value = true;
      for (let i = 0; i < itineraireOrderLastVue.value.length; i++) {
        let clientData = await getContratByClient(itineraireOrderLastVue.value[i]);
        console.log("clientData", clientData);

        let clientDataTab = Object.values(clientData);

        let clientFrom = clientDataTab.find(
          (val) => val.client == itineraireOrderLastVue.value[i].clients[0]
        );
        let clientTo = clientDataTab.find(
          (val) => val.client == itineraireOrderLastVue.value[i].clients[1]
        );

        let sortie = {
          from:
            clientDataTab[0].dataSortie == undefined ? [] : clientDataTab[0].dataSortie,
          to: clientDataTab[1].dataSortie == undefined ? [] : clientDataTab[1].dataSortie,
        };

        let stock = {
          from: clientDataTab[0].dataStock == undefined ? [] : clientDataTab[0].dataStock,
          to: clientDataTab[1].dataStock == undefined ? [] : clientDataTab[1].dataStock,
        };

        itineraireOrderLastVue.value[i]["matriculeListeSortieAll"] = formatToShow(
          sortie.from.concat(stock.from)
        );
        itineraireOrderLastVue.value[i]["matriculeListeStockAll"] = formatToShow(
          sortie.to.concat(stock.to)
        );

        console.log(
          'itineraireOrderLastVue.value[i]["matriculeListeSortieAll"]',
          itineraireOrderLastVue.value[i]["matriculeListeSortieAll"]
        );
        console.log(
          'itineraireOrderLastVue.value[i]["matriculeListeStockAll"]',
          itineraireOrderLastVue.value[i]["matriculeListeStockAll"]
        );

        itineraireOrderLastVue.value[i]["id"] = clientFrom.id + "_" + clientTo.id;
        itineraireOrderLastVue.value[i]["idFrom"] = clientFrom.id;
        itineraireOrderLastVue.value[i]["idTo"] = clientTo.id;
        itineraireOrderLastVue.value[i]["posFrom"] = {
          posX: clientFrom.posX,
          posY: clientFrom.posY,
        };
        itineraireOrderLastVue.value[i]["posTo"] = {
          posX: clientTo.posX,
          posY: clientTo.posY,
        };

        verifItineraire(
          _.cloneDeep(itineraireOrderLastVue.value[i]),
          i + 1,
          itineraireOrderLastVue.value.length,
          function () {
            mapIsLoading.value = false;
          }
        );
      }

      itineraireValidTab.value = _.cloneDeep(filteredEvent);
      itineraireOrderInitialValue.value = _.cloneDeep(itineraireOrderLastVue.value);
    };

    const {
      calendarEvents,
      calendarOptions,
      convertEventToFMdata,
      updateCalendarData,
    } = calendarData(eventClicked, windowHeight);

    return {
      map,
      position,
      // getItineraireDataSavedSorted,
      itineraireDataSaved,
      itineraireOrder,
      agencyFilter,
      getItineraireTotalSummary,
      itineraireValidTab,
      driversListe,
      typeListe,
      showFullPath,
      clearMap,
      validItineraire,
      calendarOptions,
      calendarEvents,
      showValidatedItineraire,
      eventsColor,
      getUnknowAd,
      getClientsPosition,
      getClientsAllPath,
      verifItineraire,
      gpsPositionByClient,
      itineraireOrderLastVue,
      reloadIteneraire,
      convertEventToFMdata,
      updateCalendarData,
      mapIsLoading,
      getItineraireOrder,
      getItineraireOrderLastVue,
      showCalendarEdition,
      windowHeight,
      markerDataToShow,
      validationModal,
      setNewNrbDayToShow,
      periodListe,
      contratPeriode,
      itineraireOrderInitialValue,
      getContrat,
    };
  },
  data() {
    return {
      showContratsTab: false,
      clientKeyToShow: [
        { value: "client", text: "Client", sortable: true },
        { value: "dataSortie", text: "Materiel à récupérer", sortable: false },
        { value: "dataStock", text: "Materiel à livrer", sortable: false },
        // { value: "CLD_SOUS_FAMILLE", text: "Sous famille", sortable: true },
        // { value: "CLD_DATE_RETOUR", text: "Retour", sortable: true },
        // { value: "CLD_DATE_DEPART", text: "Sortie", sortable: true },
        // { value: "CLD_POIDS", text: "Poids", sortable: true },
      ],
      contratKeyToShow: [
        // { value: "CLD_DESCRIPTION", text: "Description", sortable: true },
        { value: "CLD_NUM_CONTRAT", text: "Contrat", sortable: true },
        { value: "CLD_FAMILLE", text: "Famille", sortable: true },
        { value: "CLD_SOUS_FAMILLE", text: "Sous famille", sortable: true },
        { value: "CLD_MATRICULE", text: "Matricul", sortable: true },
        { value: "CLD_DATE_LIVRAISON_DEPART", text: "Livraison", sortable: true },
        { value: "CLD_DATE_LIVRAISON_RETOUR", text: "Récurépation", sortable: true },
        { value: "CLD_POIDS", text: "Poids", sortable: true },
      ],
      showTimePanel: false,
      firstLoad: true,
    };
  },
  watch: {
    // itineraireValidTab() {
    //   console.log("watch itineraireValidTab");

    //   // if (val != undefined)
    //   this.validationModal = true;
    // },
    showCalendarEdition(val) {
      if (val == false) {
        this.itineraireValidTab = undefined;
      }
    },
    isPathLoaded(val) {
      if (val == false) {
        this.clearMap();
        this.firstLoad = false;
      }
      this.clearMap();
    },
  },
  onBeforeUnmount() {
    if (this.map) {
      this.map.remove();
    }
  },
  computed: {
    isPathLoaded() {
      return false;
      // if (this.firstLoad == false) return false;
      // if (this.getAgencyFiltered.length == 0) return true;
      // if (
      //   this.getItineraireDataSavedSorted.length >=
      //   this.position.length * (this.position.length - 1) - this.getUnknowAd
      // )
      //   return false;
      // else return true;
    },
    getAgencyFiltered() {
      if (this.agencyFilter != undefined) {
        let agencyFiltered = [];
        for (let i = 0; i < this.getClientsAllPath.length; i++) {
          let clients = this.getClientsAllPath[i].clients;
          if (this.agencyFilter.client) {
            if (clients[0].includes(this.agencyFilter.client)) {
              agencyFiltered.push(this.getClientsAllPath[i]);
            }
          } else {
            if (clients[0].includes(this.agencyFilter.clients[1])) {
              agencyFiltered.push(this.getClientsAllPath[i]);
            }
          }
        }
        return agencyFiltered;
      } else {
        return this.getClientsAllPath;
      }
    },
  },
  components: {
    Vue3EasyDataTable,
    mapGps,
    itineraireCalendar,
    itineraireEdition,
    withdrawalList,
  },

  methods: {
    setContratSate(data, resetOldData) {
      let that = this;

      if (resetOldData) {
        for (let i = 0; i < this.itineraireOrderInitialValue.length; i++) {
          let oldSend = this.itineraireOrderInitialValue[i].matriculeListeStock;
          let oldRecup = this.itineraireOrderInitialValue[i].matriculeListeSortie;

          let done = oldSend.length + oldRecup.length;
          let cnt = 0;
          let itsLaste = this.itineraireOrderInitialValue[i + 1] == undefined;

          for (let a = 0; a < oldSend.length; a++) {
            engine.update_mat_livraison_state(
              oldSend[a].CLD_ID_CONTRAT_LOC_DATA,
              { CLD_LIVRAISON_DEPART_STATE: 0 },
              function () {
                cnt += 1;
                if (data.length == 0 && cnt == done && itsLaste) that.getContrat();
              }
            );
          }

          for (let a = 0; a < oldRecup.length; a++) {
            engine.update_mat_livraison_state(
              oldRecup[a].CLD_ID_CONTRAT_LOC_DATA,
              { CLD_LIVRAISON_RETOUR_STATE: 0 },
              function () {
                cnt += 1;
                if (data.length == 0 && cnt == done && itsLaste) that.getContrat();
              }
            );
          }
        }
      }

      for (let i = 0; i < data.length; i++) {
        let send = data[i].matriculeListeStock;
        let recup = data[i].matriculeListeSortie;

        let done = send.length + recup.length;
        let cnt = 0;
        let itsLaste = data[i + 1] == undefined;

        for (let a = 0; a < send.length; a++) {
          engine.update_mat_livraison_state(
            send[a].CLD_ID_CONTRAT_LOC_DATA,
            { CLD_LIVRAISON_DEPART_STATE: 1 },
            function () {
              cnt += 1;
              if (cnt == done && itsLaste) that.getContrat();
            }
          );
        }

        for (let a = 0; a < recup.length; a++) {
          engine.update_mat_livraison_state(
            recup[a].CLD_ID_CONTRAT_LOC_DATA,
            { CLD_LIVRAISON_RETOUR_STATE: 1 },
            function () {
              cnt += 1;
              if (cnt == done && itsLaste) that.getContrat();
            }
          );
        }
      }
    },
    showClientData(data) {
      this.markerDataToShow = { show: true, data };
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    updateFilter(data) {
      this.agencyFilter = data;
    },
    clearItineraireValidTab() {
      this.itineraireValidTab = undefined;
    },
    setItineraireValidTab(key, value) {
      this.itineraireValidTab[key] = value;
    },
    getMaxPoid(poidList) {
      let max = 0;
      let add = 0;
      for (let i = 0; i < poidList.length; i++) {
        add += poidList[i];
        if (add > max) {
          max = add;
        }
      }
      return max;
    },
    deleteEvent(event) {
      let that = this;
      engine.deleteEvent(event, function () {
        that.setContratSate([], true);
        that.updateCalendarData();
      });
      let findedEventIndex = this.calendarEvents.findIndex((val) => val.id == event.id);
      this.calendarEvents.splice(findedEventIndex, 1);
      this.itineraireValidTab = undefined;
      this.itineraireOrder.data = [];
      this.validationModal = false;
      this.showCalendarEdition = true;
    },
    editEvent(event, itineraire) {
      let that = this;
      let findedEventIndex = this.calendarEvents.findIndex((val) => val.id == event.id);
      event.title = this.getEventTitle(event);
      event.color = this.eventsColor[event.type];
      this.calendarEvents[findedEventIndex] = event;
      this.itineraireValidTab = undefined;

      let fmData = this.convertEventToFMdata(event);
      fmData["recap"] = JSON.stringify(itineraire);

      engine.editEvent(fmData, function () {
        that.setContratSate(itineraire, true);
        that.updateCalendarData();
      });
      this.itineraireOrder.data = [];
      this.validationModal = false;
      this.showCalendarEdition = true;
    },
    addEvent(event, itineraire) {
      let that = this;
      if (event) {
        event["id"] = uuid.v1();
        event.title = this.getEventTitle(event);
        event.color = this.eventsColor[event.type];

        this.calendarEvents.push(event);
      }

      let fmData = this.convertEventToFMdata(event);
      fmData["recap"] = JSON.stringify(itineraire);

      engine.addEvent(fmData, function () {
        that.setContratSate(itineraire, false);
        that.updateCalendarData();
      });
      this.itineraireValidTab = undefined;
      this.itineraireOrder.data = [];
      this.validationModal = false;
      this.showCalendarEdition = true;
    },
    // convertEventToFMdata(event) {
    //   return {
    //     event_id: event.id,
    //     nom: event.name,
    //     description: event.title,
    //     debut: event.start,
    //     debut_timestamp: parseInt(moment(event.start).format('x')),
    //     temps: event.time,
    //     distance: event.distance,
    //     poid: event.poid.join('|'),
    //     chauffeur: event.driver,
    //     // recap: JSON.stringify(itineraire)
    //   }
    // },
    getEventTitle(event) {
      let title =
        event.name.toUpperCase() +
        " | " +
        event.distance +
        " | " +
        event.time +
        " | " +
        this.getMaxPoid(event.poid) +
        " Kg | " +
        // event.type +
        // " | " +
        event.driver;
      return title;
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    dateChange(data, item) {
      item.start = moment(data).format("YYYY-MM-DD HH:mm");
    },
    setItineraireOrder(elem) {
      let newElem = JSON.parse(JSON.stringify(elem));
      // newElem['poid'] = 0
      this.verifItineraire(newElem);
    },
    setItineraireOrderUp(elem) {
      let index = this.itineraireOrder.data.findIndex(
        (val) => val.idItineraire == elem.idItineraire
      );
      this.itineraireOrder.data.splice(index, 1);
      this.itineraireOrder.data.splice(index - 1, 0, elem);
    },
    setItineraireOrderDown(elem) {
      let index = this.itineraireOrder.data.findIndex(
        (val) => val.idItineraire == elem.idItineraire
      );
      this.itineraireOrder.data.splice(index, 1);
      this.itineraireOrder.data.splice(index + 1, 0, elem);
    },
    deleteFromItineraire(elem) {
      elem.poid = 0;
      let index = this.itineraireOrder.data.findIndex(
        (val) => val.idItineraire == elem.idItineraire
      );
      this.itineraireOrder.data.splice(index, 1);
    },
  },
};
</script>

<style>
@import "../style.css";
</style>
